<template>
    <div class="box">
        <div class="from_data">
            <div class="title">联系人信息</div>
            <van-form @submit="onSubmit" class="form_info">
                <van-field
                    v-model="address.name"
                    placeholder="真实姓名"
                />
                <van-field
                    v-model="address.mobile"
                    placeholder="电话"
                />
                <van-field
                    readonly
                    clickable
                    :value="value"
                    placeholder="省 市 区"
                    @click="showArea = true"
                    right-icon="arrow"
                />
                <van-popup v-model="showArea" position="bottom">
                    <van-area
                        :area-list="areaList"
                        @confirm="onConfirm"
                        @cancel="showArea = false"
                    />
                </van-popup>
                <van-field
                    v-model="address.full_address"
                    placeholder="详细信息"
                />
            </van-form>
            <div class="wire"></div>
            <div class="reset" @click="reset">清空</div>
        </div>
        <div class="btn_box">
            <button class="btn" @click="isShowDialog" :style="{'--btnColor':btnColor}">提交</button>
        </div>
        <van-dialog v-model="show" title="奖品邮寄信息" @confirm="onSubmit" show-cancel-button>
          <div class="affirm_address">
            <!-- <div>收件人: {{this.address.name}}</div>
            <div>联系方式: {{this.address.mobile}}</div>
            <div>收件地址: {{this.value}}{{this.address.full_address}}</div> -->
            <div class="title">
              <div class="info">
                <div>收件人：</div>
                <div>{{this.address.name}}</div>
              </div>
              <div class="info">
                <div>联系方式：</div>
                <div>{{this.address.mobile}}</div>
              </div>
              <div class="info">
                <div>收件地址：</div>
                <div>{{this.value}}</div>
              </div>
              <div class="info">
                <div>详细地址：</div>
                <div>{{this.address.full_address}}</div>
              </div>
            </div>
            <div class="warning">* 信息确认后无法更改</div>
          </div>
        </van-dialog>
    </div>
</template>

<script>
import { areaList } from '@vant/area-data'
import { setAddress } from '@/api/api'
import { get } from '../../../utils/token'
export default {
  data () {
    return {
      address: {
        name: '',
        mobile: '',
        full_address: '',
        province: '', // 省
        city: '', // 市
        district: '', // 区县
        award_record_id: this.$route.params.id
      },
      value: '',
      showArea: false,
      areaList,
      isAccomplish: false,
      btnColor: '#CCC',
      mobile: get('mobile'),
      show: false
    }
  },
  methods: {
    // 省市区拆分
    addressResolution () {
      const addressArr = this.value.split(' ')
      this.address.province = addressArr[0]
      this.address.city = addressArr[1]
      this.address.district = addressArr[2]
    },
    // 数据清空
    reset () {
      this.address.full_address = ''
      this.address.name = ''
      this.address.mobile = ''
      this.value = ''
    },
    isShowDialog () {
      const { isAccomplish } = this
      if (!isAccomplish) return
      this.show = true
    },
    async onSubmit () {
      try {
        const result = await setAddress(this.mobile, { ...this.address })
        if (result.code === 200) {
          this.show = false
          this.$toast.success('地址提交成功')
          setTimeout(() => {
            this.$router.push('/exerland/prizeRecord')
          }, 1000)
        }
      } catch (error) {
        this.$toast.fail('提交失败')
      }
    },
    onConfirm (values) {
      this.value = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join(' ')
      this.showArea = false
    },
    // 检查填写信息是否为空的方法
    inspectFrom () {
      let isAccomplish = true
      for (const key in this.address) {
        if (this.address[key] === '') {
          isAccomplish = false
        }
      }
      this.btnColor = isAccomplish ? '#5EC8A1' : '#CCC'
      return isAccomplish
    }
  },
  watch: {
    address: {
      handler () {
        this.isAccomplish = this.inspectFrom()
      },
      deep: true
    },
    value () {
      this.addressResolution()
    //   this.isAccomplish = this.inspectFrom()
    }
  }

}
</script>

<style lang="scss" scoped>
.box{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100vh;
    width: 100%;
    background: #F2F2F7;
    text-align: center;
    .affirm_address {
      margin: 15px 0 20px 0;
      .warning {
        margin-top: 10px;
        font-size: 12px;
        color: red;
      }
      .title {
        // width: 50%;
        // text-align: start;
        // margin-left: 30px;
        .info {
          display: flex;
          margin: 2px 0 2px 20px;
          & > div:nth-child(1){
            width: 30%;
            text-align: start;
          }
          & > div:nth-child(2){
            width: 70%;
            text-align: start;
          }
        }
      }
      .info {
        // text-align: start;
      }
    }
    .from_data {
        display:inline-block;
        width: 350px;
        height: 325px;
        margin: 17px auto 0;
        box-shadow: 0px 1px 15px 0px rgba(158, 158, 158, 0.1);
        border-radius: 10px;
        background-color: #fff;
        .form_info {
            // margin-right: 20px;
        }
        .wire {
            width: 318px;
            border-bottom: 1px solid  #EEEEEE;
            margin: 0 auto;
        }
        .reset{
            width: 28px;
            height: 13.5px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #777777;
            line-height: 13.5px;
            margin: 24.5px 0 0 285.5px;
        }
        .title {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            height: 15.5px;
            line-height: 15.5px;
            width: 80px;
            margin: 24px 0 36px 19.5px;
        }
    }
    .btn_box {
        width: 100%;
        height: 85px;
        background-color: #fff;
        line-height: 85px;
        .btn {
            width: 200px;
            height: 44px;
            line-height: 44px;
            background: var(--btnColor);
            border-radius: 22px;
            border: none;
            vertical-align: middle;
            font-size: 15px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
        }
    }
}
</style>
